import { connect } from "react-redux";
import SiteAssignee from "./siteAssignee";
import { bindActionCreators } from "redux";
import { getAssigneeList, postAssignee } from "services/redux/installation/siteAssign/action";
import {newAssignee} from "../../../services/redux/BulkAssignment/action";

const mapStateToProps = (state) => ({
  assigneeList: state.siteAssigneeReducer.assigneeList,
  newAssigneeRes: state.bulkAssignmentReducer.newAssigneeRes,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAssigneeList,
      postAssignee,
      newAssignee
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteAssignee);
